import { Divider } from "@mui/material"

export const SectionDivider = () => <Divider />
